export default __webpack_public_path__ + "caa6fe2fc8a160efb232c0127f12e50b.jpg";